// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prdecs.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const protocol = window.location.protocol;
const domainList = window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
const domainPrepix = domainList[0];
domainList[0] = '';
const domain = domainList.join('.');

const alertnowextnPrepix = domainPrepix ===  'alertnow0' ? 'alertnowextn0' : `${domainPrepix}extn`;
const alertnowextapiPrepix = domainPrepix === 'alertnow0' ? 'alertnowextapi0' : `${domainPrepix}extapi`;

export const environment = {
    production: true,
    envName: 'PROD',

    opsNowUrl : `${protocol}//${domainPrepix}${domain}` + '/',
    apiUrl: `${protocol}//alertnowprod.an.opsnow.com/web`,
    extnUrl: `https://alertnowextn.opsnow.com`,
    ssoUrl: `https://auth${domain}/`,
    notiUrl: `${protocol}//alertnowprod.an.opsnow.com/external`,

    uploadApi: '',
    portalUrl: `https://service${domain}/`,
    noticeUrl: `https://service${domain}/notice`,
    permissionUrl: `//service${domain}/permission`,
    chatbotUrl: `https://opsbot-front-prod.okc1.opsnow.com/`,
    supportUrl: `https://bespinglobal-helpdesk.freshservice.com/support/home`
    // supportUrl: `https://sso${domain}/zendesk/authentication?return_to=https://opsnowsupport.zendesk.com/hc`
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts